export default function Process({ t }) {
  return (
    <section id="process" className="py-20 sm:py-32" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="max-w-2xl mb-14 reveal">
          <span className="label-eyebrow">{t.process.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3">{t.process.title}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.process.steps.map((s) => (
            <div
              key={s.n}
              className="card-surface p-8 reveal relative overflow-hidden"
              data-testid={`process-step-${s.n}`}
            >
              <div className="absolute top-4 right-5 font-heading text-7xl text-[var(--bg)]">
                {s.n}
              </div>
              <div className="relative">
                <div className="label-eyebrow text-[var(--accent)]">{s.n}</div>
                <h3 className="font-heading text-2xl mt-3 mb-3">{s.title}</h3>
                <p className="text-[var(--body)]">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
